export const and =
  <T>(...predicates: ((value: T) => boolean)[]) =>
  (value: T): boolean =>
    predicates.every((predicate) => predicate(value));

export const or =
  <T>(...predicates: ((value: T) => boolean)[]) =>
  (value: T): boolean =>
    predicates.some((predicate) => predicate(value));
